<script>
import { Line } from 'vue-chartjs';
import * as chartFormatting from '@/utilities/chart-formatting.js';
import debounce from 'lodash/debounce';

const data = [
  [
    0,
    4047,
    14061,
    40552,
    78315,
    152476,
    267702,
    399257,
    571907,
    716735,
    1055813,
    1384911,
    1740521,
    1906131,
    2550732,
    3011926,
    3446817,
    3881121,
    4523466,
    4770005,
    5510457,
    5911006,
    6791157,
    7476526,
    8268576,
    8911305,
  ]
];

const firstYear = 2018;
const lastYear = 2024;
const startingQuarter = 3;
const endingQuarter = 4;

const chartSpec = {
  labels: [],
  datasets: [
    {
      borderWidth: 1,
      data: data[0],
      pointRadius: 0,
      pointHoverRadius: 0,
      lineTension: 0.4
    }
  ]
};
const chartOptions = {
  maintainAspectRatio: false,
  layout: {
    padding: {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }
  },
  animation: {
    easing: chartFormatting.animationEasing,
    duration: chartFormatting.animationDuration
  },
  legend: {
    display: false
  },
  tooltips: {
    enabled: false
  },
  scales: {
    yAxes: [
      {
        ticks: {
          padding: 20,
          autoSkip: true,
          beginAtZero: true,
          fontColor: '#424242',
          fontFamily: chartFormatting.labelFontFamily,
          fontSize: 14,
          lineHeight: 3,
          maxTicksLimit: 10,
          callback: function (val) { // Format the dollars on the Y-Axis
            if (val >= 1000000000) { // $x.xB
              return '$' + (val / 1000000000) + 'B';
            } else if (val >= 1000000) { // $x.xM
              return '$' + (val / 1000000) + 'M';
            } else { // $xx,xxx
              return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            }
          }
        },
        gridLines: {
          drawTicks: false,
          display: false
        }
      }
    ],
    xAxes: [
      {
        gridLines: {
          zeroLineColor: 'transparent'
        },
        ticks: chartFormatting.xLabelFormat
      }
    ]
  }
};

export default {
  name: 'MvpDistributionsChart',
  extends: Line,
  data: function () {
    return {
      chartSpec: chartSpec,
      chartOptions: chartOptions
    };
  },
  mounted () {
    this.resize();
    document.addEventListener('aos:in:mvp-distributions-chart', this.aosChartEvent);
    this.handleDebouncedResize = debounce(this.resize, 50);
    window.addEventListener('resize', this.handleDebouncedResize);
  },
  beforeDestroy () {
    document.removeEventListener('aos:in:mvp-distributions-chart', this.aosChartEvent);
    window.removeEventListener('resize', this.handleDebouncedResize);
  },
  methods: {
    aosChartEvent: function (event) {
      document.removeEventListener('aos:in:mvp-distributions-chart', this.aosChartEvent);
      this.render();
    },
    render: function () {
      const ctx = this.$refs.canvas.getContext('2d');
      const container = $(this.$refs.canvas).parents('.chart-container');
      var gradientFill = (
        ctx.createLinearGradient(
          0,
          container.height() / 2,
          container.width(),
          container.height() / 2
        )
      );
      gradientFill.addColorStop(0, '#7AC9D5');
      gradientFill.addColorStop(1, '#1E4B66');
      this.chartSpec.datasets[0].backgroundColor = gradientFill;
      this.renderChart(this.chartSpec, this.chartOptions);
    },
    resize: function () {
      this.chartSpec.labels = (
        chartFormatting.determineQuarterlyXLabels(
          firstYear,
          lastYear,
          startingQuarter,
          endingQuarter,
          () => {
            if (window.innerWidth >= 1024) {
              return 2;
            } else if (window.innerWidth >= 640) {
              return 4;
            } else {
              return 6;
            }
          }
        )
      );
      this.render();
    }
  }
};
</script>
